import get from 'lodash/get';

function getPaymentMethodCategories(state) {
  const categories = get(
    state,
    ['paymentConfiguration', 'paymentMethodCategories'],
    []
  );
  return Object.values(categories);
}

export default getPaymentMethodCategories;
